<template>
    <div class="loginPageWrap selectUserWrap">
        <header>
            <div class="wrap">
                <div class="container">
                    <img src="/assets/img/logo_transparent.svg" alt="logo" class="logo">
                </div>
            </div>
        </header>

        <div class="loginContent">
            <div class="form">
                <h2 v-if="$mq=='lg'"><strong>{{'pages/select-user.traveller' | trans}} </strong><br/>{{'pages/select-user.select-account' | trans}}</h2>

                <MultipleAccounts
                    v-if="multipleAccounts.length"
                    :accountsData="multipleAccounts"
                />

            </div>
			<div class="photos-wrapper">
				<div class="photos stepOne">
					<div class="photo photo-1">
						<img src="/assets/img/login/travel3.png" alt="travel3">
					</div>
					<div class="photos-column">
						<div class="photo photo-2">
							<img src="/assets/img/login/travel1.png" alt="travel1">
						</div>
						<div class="photo photo-3">
							<img src="/assets/img/login/travel2.png" alt="travel2">
						</div>
					</div>
				</div>
			</div>
        </div>
        <footer v-if="$mq=='lg'">
            <div class="resize">
                <div>
                    <ul class="socials">
                        <li>
                            <a href="https://www.facebook.com/flynowpaylatertravel/" target="_blank">
                                <i class="fa fa-facebook-f"></i>
                            </a>
                        </li>
                        <li>
                            <a href="https://twitter.com/vuelouk" target="_blank">
                                <i class="fa fa-twitter"></i>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/flynowpaylatertravel/" target="_blank">
                                <i class="fa fa-instagram"></i>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.linkedin.com/company/getvuelo-co-uk/" target="_blank">
                                <i class="fa fa-linkedin"></i>
                            </a>
                        </li>
                    </ul>
                    <p class="copyright">
                        <span class="block">Copyright &copy; 2020</span>
                         <a href="https://www.vuelo.com/en/">Vuelo.com</a>
                    </p>
                </div>

            </div>

        </footer>

    </div>

</template>

<script>
    import MultipleAccounts from '../components/Login/MultipleAccounts';
    import helper from '../services/helper';
    import store from '../store'

    export default {
        data() {
            return {
                multipleAccounts: []
            }
        },
        components: {
            MultipleAccounts
        },
        methods: {
            initMultipleUsers: function () {


                helper.getUserAccountsInfo()
					.then((users) => {
						var usersArray = [];

						for (let userIndex in users) {
							if (parseInt(userIndex) === userIndex * 1) {
								usersArray.push(users[userIndex]);
							}
						}



						if (usersArray.length === 1) {
							 this.$store.dispatch('saveUserData', {user: usersArray[0]})
                                 .then(() => this.$store.dispatch('getDocuments'))
					             .then(() => this.$router.push('/'));


						} else if (usersArray.length > 1) {
                            this.multipleAccounts = this.$store.state.linkedUsers = usersArray;
						} else {
							console.log('there is no linked account');
						}
                	})

            },
        },
        created() {
            this.initMultipleUsers();
        }
    }
</script>
